import { ArrowLeftIcon, ChevronLeft, SparklesIcon } from "lucide-react";
import {
    Button,
    ButtonColour,
    ButtonVariant,
} from "@/components/Button/Button";
import { IconButton } from "@/components/Button/IconButton";
import { CreditSpendIndicator } from "@/components/Credits/CreditSpendIndicator";
import { SmartMatchIcon } from "@/components/Icons/Icons";
import { ICreditAction } from "@/types/creditAction";
interface ModalFooterProps {
    primaryActionText: string;
    primaryActionOnClick: () => void;
    secondaryActionText?: string;
    secondaryActionOnClick?: () => void;
    thirdActionText?: string;
    thirdActionOnClick?: () => void;
    thirdActionVariant?: ButtonVariant;
    thirdActionColor?: ButtonColour;
    primaryActionLoading?: boolean;
    primaryActionDisabled?: boolean;
    primaryActionVariant?: ButtonVariant;
    secondaryActionVariant?: ButtonVariant;
    primaryActionColor?: ButtonColour;
    secondaryActionColor?: ButtonColour;
    creditAction?: ICreditAction;
}

export const ModalFooter = ({
    primaryActionText,
    primaryActionOnClick,
    secondaryActionText,
    secondaryActionOnClick,
    thirdActionText,
    thirdActionOnClick,
    thirdActionVariant = "solid",
    thirdActionColor = "grey",
    primaryActionLoading,
    primaryActionDisabled,
    primaryActionVariant = "solid",
    secondaryActionVariant = "solid",
    primaryActionColor = "primary",
    secondaryActionColor = "grey",
    creditAction,
}: ModalFooterProps) => (
    <div className="mt-3 flex items-center justify-end">
        {thirdActionText && (
            <>
                <Button
                    onClick={thirdActionOnClick}
                    color={thirdActionColor}
                    variant={thirdActionVariant}
                    className="mr-auto hidden lg:flex"
                    leftIcon={
                        thirdActionText === "Back" && <ChevronLeft size={16} />
                    }
                >
                    {thirdActionText}
                </Button>
                {thirdActionText === "Back" && (
                    <IconButton
                        onClick={thirdActionOnClick}
                        color={thirdActionColor}
                        variant={thirdActionVariant}
                        className="mr-auto flex lg:hidden"
                    >
                        <ChevronLeft size={16} />
                    </IconButton>
                )}
            </>
        )}
        <div className="flex items-center gap-3">
            {secondaryActionText && (
                <Button
                    onClick={secondaryActionOnClick}
                    color={secondaryActionColor}
                    variant={secondaryActionVariant}
                    leftIcon={
                        secondaryActionText === "Smart Match" && (
                            <SmartMatchIcon
                                gradient
                                className="h-7 w-7"
                            />
                        )
                    }
                >
                    {secondaryActionText}
                </Button>
            )}
            {creditAction ? (
                <CreditSpendIndicator creditAction={creditAction}>
                    <Button
                        onClick={primaryActionOnClick}
                        loading={primaryActionLoading}
                        disabled={primaryActionDisabled}
                        variant={primaryActionVariant}
                        color={primaryActionColor}
                        leftIcon={
                            primaryActionText === "Upgrade" && (
                                <SparklesIcon className="h-4 w-4" />
                            )
                        }
                    >
                        {primaryActionText}
                    </Button>
                </CreditSpendIndicator>
            ) : (
                <Button
                    onClick={primaryActionOnClick}
                    loading={primaryActionLoading}
                    disabled={primaryActionDisabled}
                    variant={primaryActionVariant}
                    color={primaryActionColor}
                    leftIcon={
                        primaryActionText === "Upgrade" && (
                            <SparklesIcon className="h-4 w-4" />
                        )
                    }
                >
                    {primaryActionText}
                </Button>
            )}
        </div>
    </div>
);
